import _ from "lodash";
import "./Dropdown.scss";

const Dropdown = ({ ...props }) => (
  <div
    id={props.id}
    className="dropdown"
    style={{
      overflow: props.overflow ? props.overflow : "unset",
      maxHeight: props.maxHeight ? props.maxHeight + "px" : "unset",
      padding: props.padding ? props.padding : "none",
      width: props.width,
      marginLeft: props.marginLeft ? props.marginLeft + "px" : "unset",
      marginTop: props.marginTop ? props.marginTop + "px" : "unset",
    }}
    onMouseEnter={props.onMouseEnter || _.noop}
    onMouseLeave={props.onMouseLeave || _.noop}
  >
    {props.children}
  </div>
);
export default Dropdown;
